import { render, staticRenderFns } from "./ListBuyBox.vue?vue&type=template&id=a2395fb2&scoped=true"
import script from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ListBuyBox.vue?vue&type=style&index=0&id=a2395fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2395fb2",
  null
  
)

export default component.exports